import {
    Card,
    CardHeader,
    CardTitle,
    CardContent,
  } from "@/components/ui/card";
  import { ArrowUpRight } from "lucide-react";
  
  const items = [
    {
      title: "Waarom een Sales Coach?",
      description: (
        <>
          <p>
            Veel bedrijven lopen niet vast op hun product — maar op hun
            verkoopgesprekken.
          </p>
          <p className="mt-3">
            Een salescoach helpt je om gesprekken te verfijnen naar topniveau.
          </p>
          <ul className="mt-4 space-y-2 text-muted-foreground">
            <li>• Natuurlijke, overtuigende communicatie</li>
            <li>• Meer controle in elk gesprek</li>
            <li>• Sterkere mindset in onderhandelingen</li>
          </ul>
        </>
      ),
    },
    {
      title: "Meer omzet zonder harder te werken",
      description: (
        <>
          <p>Groei komt niet door meer doen, maar door slimmer verkopen.</p>
          <ul className="mt-4 space-y-2 text-muted-foreground">
            <li>• Hogere conversie zonder extra leads</li>
            <li>• Kleine verbeteringen → grote omzetstijging</li>
            <li>• Minder druk, meer resultaat</li>
          </ul>
        </>
      ),
    },
    {
      title: "Sterkere klantrelaties",
      description: (
        <>
          <p>Goede sales stopt niet bij de deal — daar begint het.</p>
          <ul className="mt-4 space-y-2 text-muted-foreground">
            <li>• Langdurige klantrelaties</li>
            <li>• Meer herhaalaankopen</li>
            <li>• Menselijke, natuurlijke gesprekken</li>
          </ul>
        </>
      ),
    },
    {
      title: "Sterkere marges & prijspositionering",
      description: (
        <>
          <p>Veel bedrijven laten winst liggen in hun verkoopproces.</p>
          <ul className="mt-4 space-y-2 text-muted-foreground">
            <li>• Sterk staan in prijsgesprekken</li>
            <li>• Waarde helder communiceren</li>
            <li>• Betere onderhandelingspositie</li>
          </ul>
        </>
      ),
    },
  ];
  
  export const SellingCards = () => {
    return (
      <section className="relative w-full overflow-hidden py-24 px-4">
        {/* background */}
        <div className="absolute inset-0 bg-gradient-to-b from-background via-muted/10 to-background" />
        <div className="absolute inset-0 bg-[radial-gradient(circle_at_20%_10%,rgba(249,115,22,0.12),transparent_40%),radial-gradient(circle_at_80%_80%,rgba(249,115,22,0.08),transparent_45%)]" />
  
        <div className="relative mx-auto max-w-5xl">
          {/* header */}
          <div className="mb-16">
            <h2 className="text-4xl md:text-5xl font-semibold tracking-tight">
              Groei in sales begint bij{" "}
              <span className="bg-gradient-to-r from-orange-500 to-amber-400 bg-clip-text text-transparent">
                betere gesprekken
              </span>
            </h2>
            <p className="mt-4 text-muted-foreground max-w-xl">
              Geen trucjes. Maar een gestructureerde manier van verkopen die
              consistent resultaat oplevert.
            </p>
          </div>
  
          {/* timeline line */}
          <div className="relative border-l border-border/50 pl-8 space-y-14">
            {items.map((item, index) => (
              <div key={index} className="relative group">
                {/* dot */}
                <div className="absolute -left-[41px] top-2 h-4 w-4 rounded-full bg-gradient-to-br from-orange-500 to-amber-400 shadow-md ring-4 ring-background" />
  
                <Card className="relative overflow-hidden border border-border/60 bg-background/60 backdrop-blur-xl shadow-[0_10px_40px_-20px_rgba(0,0,0,0.4)] transition-all duration-300 hover:-translate-y-1 hover:border-orange-500/40">
                  {/* glow */}
                  <div className="absolute -right-24 -top-24 h-48 w-48 bg-orange-500/10 blur-3xl opacity-0 group-hover:opacity-100 transition" />
  
                  <CardHeader>
                    <CardTitle className="text-2xl md:text-3xl font-medium">
                      {item.title}
                    </CardTitle>
                  </CardHeader>
  
                  <CardContent className="text-muted-foreground leading-7">
                    {item.description}
  
                    <div className="mt-6 inline-flex items-center gap-2 text-sm font-medium text-foreground">
                      <ArrowUpRight className="h-4 w-4 text-orange-500" />
                      Direct toepasbaar in sales gesprekken
                    </div>
                  </CardContent>
                </Card>
              </div>
            ))}
          </div>
        </div>
      </section>
    );
  };